import actions from './actions/en-US';
import appointmentRequest from './appointment-request/en-US';
import appointment from './appointment/en-US';
import confirmAction from './confirm-action/de-DE';
import dataSecurity from './data-security/en-US';
import enums from './enums/en-US';
import facilitySelection from './facility-selection/en-US';
import footer from './footer/en-US';
import home from './home/en-US';
import imprint from './imprint/en-US';
import placeholders from './placeholders/en-US';
import passwordReset from './reset-password/de-DE';
import signup from './signup/en-US';
import slotSelection from './slot-selection/en-US';
import user from './user/en-US';

export default {
  'locale.de-DE': 'Deutsch',
  'locale.en-US': 'English',

  ...actions,
  ...dataSecurity,
  ...home,
  ...placeholders,
  ...slotSelection,
  ...signup,
  ...footer,
  ...enums,
  ...appointment,
  ...appointmentRequest,
  ...facilitySelection,
  ...imprint,
  ...user,
  ...confirmAction,
  ...passwordReset,

  // MISC
  'not-found.message': 'We are sorry. The requested page does not exist.',
  'not-found.back-home': 'To the home page',

  phone: 'Phone number',
  address: 'Address',

  current: 'Current',

  'e-mail': 'E-Mail',

  'error.title': 'Something went wrong',
  'error.message': 'An unexpected error has occurred',

  documents: 'Documents',
  user: 'User',
  account: 'Account',
  empty: 'No data available',
  email: 'E-Mail',
  'email.required': 'Please enter your email address',
  password: 'Passwort',
  'password.required': 'Please enter your password',

  upcoming: 'Upcoming',
  past: 'Past',
  requested: 'Requests',

  morning: 'Morning',
  noon: 'Noon',
  afternoon: 'Afternoon',
  evening: 'Evening',

  register: 'Register account',
};
